import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { rolesAPI } from '../utils/api';
import { toast } from 'sonner';
import RolPermissionsTable from './RolPermissionsTable';

const EditRolDialog = ({ rol, menus, open, onClose, readOnly = false }) => {
  const [formData, setFormData] = useState({
    nombre: rol.nombre,
    descripcion: rol.descripcion || '',
    permisos: rol.permisos || [],
  });
  const [loading, setLoading] = useState(false);

  const isAdmin = rol.nombre === 'Administrador';
  const isDisabled = readOnly || isAdmin;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (readOnly) return;
    setLoading(true);
    try {
      await rolesAPI.update(rol.id, formData);
      toast.success('Rol actualizado exitosamente');
      onClose();
    } catch (error) {
      toast.error('Error al actualizar rol');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 gap-0 flex flex-col overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-2 shrink-0">
          <DialogTitle
            className="text-2xl font-bold text-[#2D2D2D]"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="rol-dialog-title"
          >
            {readOnly ? 'Ver Rol' : 'Editar Rol'}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Nombre del Rol *</Label>
                <Input
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  className="border-[#c5b8a2]"
                  required
                  disabled={isDisabled}
                />
              </div>
              <div>
                <Label>Descripción</Label>
                <Input
                  value={formData.descripcion}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  className="border-[#c5b8a2]"
                  disabled={readOnly}
                />
              </div>
            </div>

            <div>
              <Label className="mb-3 block text-lg font-semibold">Permisos por Menú</Label>
              <RolPermissionsTable
                menus={menus}
                permisos={formData.permisos}
                onChange={(permisos) => setFormData((f) => ({ ...f, permisos }))}
                readOnly={isDisabled}
                allChecked={isAdmin}
              />
            </div>
          </div>

          <div className="shrink-0 px-6 py-4 bg-white border-t border-[#E8E8E7] flex justify-end gap-3">
            {readOnly ? (
              <Button type="button" variant="outline" onClick={onClose} data-testid="rol-dialog-close">
                Cerrar
              </Button>
            ) : (
              <>
                <Button type="button" variant="outline" onClick={onClose}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  disabled={loading}
                  className="bg-[#9d8272] hover:bg-[#8a7162] text-white"
                >
                  {loading ? 'Guardando...' : 'Guardar Cambios'}
                </Button>
              </>
            )}
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditRolDialog;
